module.exports = __webpack_public_path__ + "img/sx.673163a1.svg";